export async function getArticle (slug) {
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?slug=${slug}&_embed`

  const response = await fetch(url)
  const json = await response.json()

  // This endpoint returns an array of 1 item, so return that item instead
  return json[0]
}

export async function getAcfArticle (slug) {
  let acfUrl = `https://quell.staging.themoderati.com/wp-json/acf/v3/posts/{id}`

  const acfResponse = await fetch(acfUrl)
  const acf = await acfResponse.json() // This endpoint returns an array of 1 item, so return that item instead
  return acf
}

export async function getAllArticles () {
  let category = 8 // articles
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?categories=${category}&_fields=slug,id&per_page=100`

  const response = await fetch(url)
  const json = await response.json()

  return json
}

export async function getPress (slug) {
  let category = 7 // single press article
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?slug=${slug}&_embed`

  const response = await fetch(url)
  const json = await response.json()

  // This endpoint returns an array of 1 item, so return that item instead
  return json[0]
}

export async function getAllPress () {
  // This will need to be fixed to include the actual link.
  // For now, it's just using the WP posts instead of an ACF.

  let category = 7 // press
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?categories=${category}&_fields=date,id,title,content&per_page=100`

  const response = await fetch(url)
  const json = await response.json()

  return json
}

export async function getSomePress () {
  // This will need to be fixed to include the actual link.
  // For now, it's just using the WP posts instead of an ACF.
  let perPage = 6
  let category = 7 // press
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?categories=${category}&_fields=date,id,title,content&per_page=${perPage}`

  const response = await fetch(url)
  const json = await response.json()

  return json
}

export async function getSomeArticles (pageNumber = 1) {
  let perPage = 4
  let category = 8 // articles
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?page=${pageNumber}&per_page=${perPage}&statuses=public&categories=${category}&_embed`

  const response = await fetch(url)
  const maxPages = Math.ceil(response.headers.get('x-wp-total') / perPage)
  const authJwt = response.headers.get('x-jwt-refresh')
  const json = await response.json()

  return {
    json,
    maxPages,
    authJwt
  }
}

export async function getWpNewspage () {
  let acfUrl = `https://quell.staging.themoderati.com/wp-json/acf/v3/pages/777`
  const acfResponse = await fetch(acfUrl)
  const acf = await acfResponse.json() // This endpoint returns an array of 1 item, so return that item instead
  return {
    acf: acf.acf
  }
}
